import React, { useEffect, useState } from "react";
import Dolar from "../../common/dolar";
import colores from "../../shared/constants/styles";
import { Grid } from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import {
  requestPresupuestoConfirm,
  requestConfirmacionPresupuesto,
} from "../../actions/presupuesto";
import { useParams, useHistory } from "react-router-dom";
import rutas from "../../routes/constants/routes";
import logo from "../../assets/images/Barbieri-MarcaGrafica.png";
import { Link } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import MyUserService from "../../services/myUser";
import { getTerminosCondiciones } from "../../actions/configuracion";
import DownloadPoliticaReclamo from "../../common/components/politicaReclamos/downloadPoliticaReclamos";
import AlertaImpuestos from "./popUpAlertaImpuestos";
import PedidoFirme from "./popUpPedidoFirme";

const Confirmar = (props) => {
  const myUser = MyUserService.getMyUser();
  const history = useHistory();
  const time = myUser.expirationTime ? myUser.expirationTime : 300;
  const realTime = myUser.realExpirationTime ? myUser.realExpirationTime : 300;
  const [tiempoRestante, setTiempoRestante] = useState(time);
  const dispatch = useDispatch();
  const [detallesProductos, setDetallesProductos] = useState();
  const [confirmDataProductos, setConfirmDataProductos] = useState("$");
  const [textArea, setTextArea] = useState("");
  const [esPedidoFirme, setPedidoFirme] = useState(null);
  const [error, setError] = useState("");
  const [terminosCondiciones, setTerminosCondiciones] = useState("");
  const [openDialogTerminos, setOpenDialogTerminos] = useState(false);
  const [openPedidoFirme, setOpenPedidoFirme] = React.useState(false);

  var { presupuestoId } = useParams();
  // Función para formatear el tiempo en minutos y segundos
  const formatTiempoRestante = (tiempo) => {
    const minutos = Math.floor(tiempo / 60);
    const segundos = tiempo % 60;
    return `${minutos < 10 ? "0" : ""}${minutos}:${
      segundos < 10 ? "0" : ""
    }${segundos}`;
  };

  const handleChangeTextArea = (event) => {
    const inputValue = event.target.value;

    if (inputValue.length <= 150) {
      setTextArea(inputValue);
      setError("");
    } else {
      setError(
        "Se ha excedido el límite de caracteres. 150 carácteres es el máximo.",
      );
    }
  };

  const handleSelectPedidoFirma = (event) => {
    setPedidoFirme(event.target.value == 1);
  };

  useEffect(() => {
    dispatch(getTerminosCondiciones());
    dispatch(requestPresupuestoConfirm(presupuestoId));
    return () => {
      localStorage.setItem("expirationtime", realTime);
    };
  }, []);

  useEffect(() => {
    const tiempoExpiracion = time;
    const temporizador = setInterval(() => {
      setTiempoRestante((prevTiempo) => {
        const nuevoTiempo = prevTiempo - 1;
        // Guarda el nuevo tiempo restante en el almacenamiento local
        localStorage.setItem("expirationtime", nuevoTiempo);
        return nuevoTiempo;
      });
    }, 1000);

    const tiempoExpiracionMillis = tiempoExpiracion * 1000;

    const redirigir = () => {
      localStorage.setItem("expirationtime", realTime);
      history.push(`${rutas.CARRITO}`);
    };

    const expiracionTimeout = setTimeout(() => {
      redirigir();
    }, tiempoExpiracionMillis);

    return () => {
      clearInterval(temporizador);
      clearTimeout(expiracionTimeout);
    };
  }, [history]);

  const titlesBig = {
    fontWeight: "bold",
    fontSize: "1.50rem",
  };

  const dateTime = (date) => {
    let parseDate = new Date(Date.parse(date));
    return parseDate.toLocaleString().slice(0, -3);
  };

  const noTitlesBig = {
    fontWeight: "normal",
    fontSize: "1.25rem",
  };

  const titles = {
    fontWeight: "bold",
    fontSize: "1.1rem",
    marginBottom: "0.5rem",
    padding: "0",
  };

  const noTitles = {
    fontWeight: "normal",
    fontSize: "1.1rem",
    marginLeft: "0.313rem",
    marginTop: "0.313rem",
    marginBottom: "0.313rem",
    padding: "0",
  };

  const titlesLine = {
    fontWeight: "bold",
    fontSize: "1.1rem",
  };

  const noTitlesLine = {
    fontWeight: "normal",
    fontSize: "1rem",
  };

  const confirmarPresupuesto = () => {
    setOpenPedidoFirme(true);
  };

  const handleNextPedidoFirme = () => {
    if (esPedidoFirme === null) {
      return;
    }

    setOpenPedidoFirme(false);
    setOpenDialogTerminos(true);
  };

  const volverMiCarrito = () => {
    history.push(`${rutas.CARRITO}`);
  };

  const handleConfirmarTerminosCondiciones = () => {
    localStorage.setItem("expirationtime", realTime);
    setOpenDialogTerminos(false);
    dispatch(
      requestConfirmacionPresupuesto(presupuestoId, textArea, esPedidoFirme),
    );
  };

  useEffect(() => {
    if (props.successPre) {
      window.location.assign(rutas.MIS_PRESUPUESTOS);
    }
  }, [history, props]);

  const calcularPrecioUnitario = (detalle) => {
    let precioUnitario = 0;
    if (detalle?.dimension1 > 1) {
      precioUnitario =
        detalle.montoSubtotalDto / detalle?.dimension1 / detalle?.cantidadTiras;
    } else {
      precioUnitario = detalle.montoSubtotalDto / detalle?.cantidadTiras;
    }
    return precioUnitario;
  };
  const calcularTotalKilos = (items) => {
    let totalKilos = 0;

    if (items !== undefined) {
      for (let i = 0; i < items.length; i++) {
        totalKilos = items[i].pesoSubtotal + totalKilos;
      }
    }
    return totalKilos;
  };
  const calcularSubtotal = (items) => {
    let totalSubtotal = 0;

    if (items !== undefined) {
      for (let i = 0; i < items.length; i++) {
        const ml = items[i].dimension1 > 1 ? items[i].dimension1 : 1;
        totalSubtotal =
          items[i].precio * items[i].cantidadTiras * ml + totalSubtotal;
      }
    }
    return totalSubtotal;
  };
  const calcularDescuentos = (items) => {
    let totalDescuentos = 0;
    let subtotal = 0;
    let total = 0;

    if (items !== undefined) {
      for (let i = 0; i < items.length; i++) {
        const ml = items[i].dimension1 > 1 ? items[i].dimension1 : 1;
        subtotal = items[i].precio * items[i].cantidadTiras * ml + subtotal;
        total = items[i].montoSubtotalDto + total;
      }
    }

    totalDescuentos = subtotal - total;
    return totalDescuentos;
  };
  const calcularTotal = (items) => {
    let total = 0;
    if (items !== undefined) {
      for (let i = 0; i < items.length; i++) {
        total = items[i].montoSubtotalDto + total;
      }
    }
    return total;
  };
  const redondear = (monto) => {
    return Math.round((monto + Number.EPSILON) * 100) / 100;
  };

  useEffect(() => {
    if (props.presupuestoConfirm?.detalles?.$values) {
      setConfirmDataProductos(
        props.presupuestoConfirm?.detalles?.$values[0]?.moneda?.simbolo,
      );
      setDetallesProductos(props.presupuestoConfirm?.detalles?.$values);
    }
  }, [props.presupuestoConfirm]);

  useEffect(() => {
    if (props.successGetTerminos && !props.loading) {
      setTerminosCondiciones(props.terminos);
    }
  }, [props.successGetTerminos, props.loading]);

  useEffect(() => {
    setConfirmDataProductos(
      props.presupuestoConfirm?.detalles?.$values[0]?.moneda?.simbolo,
    );
    if (props.presupuesto?.presupuestoDetalles?.$values) {
      setDetallesProductos(props.presupuesto?.presupuestoDetalles?.$values);
    }
  }, [props.presupuesto]);

  const handleCloseTerminosCondiciones = () => {
    setOpenDialogTerminos(false);
  };

  const [checkedTerminos, setCheckedTerminos] = React.useState(false);
  const [checkedReclamos, setCheckedReclamos] = React.useState(false);

  const handleChangeTerminos = (event) => {
    setCheckedTerminos(event.target.checked);
  };
  const handleChangeReclamos = (event) => {
    setCheckedReclamos(event.target.checked);
  };

  return (
    <>
      <div>
        <Dolar></Dolar>

        <div
          className="d-flex justify-content-center"
          style={{ backgroundColor: colores.grisClaro }}
        >
          <hr style={{ width: "90%", color: "black" }}></hr>
        </div>
        <div
          className="d-flex justify-content-between flex-wrap align-items-center"
          style={{
            marginBottom: "0.600rem",
            paddingRight: "3rem",
            backgroundColor: colores.grisClaro,
          }}
        >
          <h1
            className="fw-bolder"
            style={{ marginLeft: "5%", fontWeight: "bold" }}
          >
            CONFIRMAR
          </h1>
          <div style={{ float: "right", marginRight: "25vw" }}>
            <h3>
              Tiempo restante para realizar la compra:{" "}
              {formatTiempoRestante(tiempoRestante)}
            </h3>
          </div>
        </div>
        <div
          className="container"
          style={{
            backgroundColor: colores.grisClaro,
            borderRadius: "15px 15px 0 0",
            padding: "3.125rem",
            marginTop: "5rem",
            marginBottom: "5rem",
            marginLeft: "5rem",
            marginRight: "5rem",
          }}
        >
          <div className="container" style={{ margin: 0 }}>
            <div className="fluid" style={{ marginBottom: "5rem" }}>
              <img src={logo} alt="Barbieri logo" height="60rem"></img>
            </div>
            <div style={{}}>
              <div style={titlesBig}>
                SOLICITUD DE PRESUPUESTO:{" "}
                <span style={noTitlesBig}>
                  {props.presupuestoConfirm?.pedidoId}
                </span>{" "}
              </div>
              <div style={titlesBig}>
                FECHA:{" "}
                <span style={noTitlesBig}>
                  {dateTime(props.presupuestoConfirm?.fecha)}
                </span>
              </div>
            </div>
            <div>
              <hr />
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="col" style={titles}>
                  CLIENTES:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.cliente}
                  </span>
                </div>
                <div className="col" style={titles}>
                  CUIT:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.documentoCliente}
                  </span>
                </div>
                <div className="col" style={titles}>
                  DOMICILIO:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.direccionCliente}
                  </span>
                </div>
              </div>
              <div>
                <div className="col" style={titles}>
                  TELEFONO:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.telefonoCliente}
                  </span>
                </div>
                <div className="col" style={titles}>
                  LISTA DE PRECIO:{" "}
                  <span style={noTitles}>{myUser.listaPrecioId}</span>
                </div>
                <div className="col" style={titles}>
                  VENDEDOR:{" "}
                  <span style={noTitles}>{myUser.nombreFantasiaVendedor}</span>
                </div>
                {/* <div className='col' style={titles}>TIPO DE CAMBIO: <span style={noTitles}>{props.presupuestoConfirm?.tipoCambio}</span></div> */}
              </div>
              <div>
                <div className="col" style={titles}>
                  MONEDA:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.moneda}
                  </span>
                </div>
                <div className="col" style={titles}>
                  CONDICION DE PAGO:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.condicionPago}
                  </span>
                </div>
                <div className="col" style={titles}>
                  CLASIFICACIÓN DE ENVÍO:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.clasificacionEnvio}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <hr />
            </div>
            <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
              <h4>DETALLE DEL PEDIDO (No contiene impuestos)</h4>
            </div>
            <Grid style={{ marginBottom: "1.5rem" }}>
              <Grid
                className="d-flex justify-content-between align-items-center"
                style={{}}
              >
                <Grid item xs={5}>
                  <p style={titlesLine}>CÓDIGO PRODUCTO</p>
                </Grid>
                <Grid item xs>
                  <p style={titlesLine}>CANT</p>
                </Grid>
                <Grid item xs>
                  <p style={titlesLine}>KILOS</p>
                </Grid>
                <Grid item xs>
                  <p style={titlesLine}>P. LISTA</p>
                </Grid>
                <Grid item xs>
                  <p style={titlesLine}>% BON</p>
                </Grid>
                <Grid item xs>
                  <p style={titlesLine}>P. UNIT</p>
                </Grid>
                <Grid item xs>
                  <p style={titlesLine}>IMPORTE</p>
                </Grid>
              </Grid>
              {detallesProductos &&
                detallesProductos?.map((detalle) => (
                  <Grid
                    className="d-flex justify-content-between align-items-center"
                    style={{}}
                    key={detalle.$id}
                  >
                    <Grid item xs={5}>
                      {detalle?.dimension1 > 1 ? (
                        <p style={noTitlesLine}>
                          {detalle.nombreProducto}-{" "}
                          {detalle?.dimension1.toFixed(2)} ml{" "}
                        </p>
                      ) : (
                        <p style={noTitlesLine}>{detalle.nombreProducto}</p>
                      )}
                    </Grid>
                    <Grid item xs>
                      <p style={noTitlesLine}>{detalle.cantidadTiras}</p>
                    </Grid>
                    <Grid item xs>
                      <p style={noTitlesLine}>
                        {detalle.pesoSubtotal?.toFixed(2)}
                      </p>
                    </Grid>
                    <Grid item xs>
                      <p style={noTitlesLine}>
                        {confirmDataProductos} {detalle?.precio?.toFixed(2)}
                      </p>
                    </Grid>
                    <Grid item xs>
                      <p style={noTitlesLine}>
                        {detalle?.descuento1 > 0
                          ? detalle?.descuento1.toFixed(2)
                          : ""}
                        {props.presupuestoConfirm?.descuentoCondicionPago > 0 &&
                          (detalle?.descuento1 > 0
                            ? " + " +
                              props.presupuestoConfirm?.descuentoCondicionPago
                            : props.presupuestoConfirm?.descuentoCondicionPago)}
                        {props.presupuestoConfirm?.descuentoCliente > 0
                          ? detalle?.descuento1 > 0 ||
                            props.presupuestoConfirm?.descuentoCondicionPago > 0
                            ? " + " + props.presupuestoConfirm?.descuentoCliente
                            : props.presupuestoConfirm?.descuentoCliente
                          : ""}
                        {!(props.presupuestoConfirm?.descuentoCliente > 0) &&
                        !(
                          props.presupuestoConfirm?.descuentoCondicionPago > 0
                        ) &&
                        !(detalle?.descuento1 > 0)
                          ? "0"
                          : ""}
                      </p>{" "}
                    </Grid>
                    <Grid item xs>
                      <p style={noTitlesLine}>
                        {confirmDataProductos}{" "}
                        {calcularPrecioUnitario(detalle).toFixed(2)}
                      </p>
                    </Grid>
                    <Grid item xs>
                      <p style={noTitlesLine}>
                        {confirmDataProductos}{" "}
                        {detalle.montoSubtotalDto?.toFixed(2)}
                      </p>
                    </Grid>
                  </Grid>
                ))}
            </Grid>
            <div>
              <hr />
            </div>
            <div>
              <div style={{ marginBottom: "1.5rem" }}>
                <Grid>
                  <Grid
                    className="d-flex justify-content-between align-items-center"
                    style={{}}
                  >
                    <Grid item xs>
                      <p style={titles}>TOTAL KILOS:</p>
                    </Grid>
                    <Grid item xs>
                      <p style={titles}>SUBTOTAL:</p>
                    </Grid>
                    <Grid item xs>
                      <p style={titles}>DESCUENTOS:</p>
                    </Grid>
                    <Grid item xs>
                      <p style={titles}>TOTAL:</p>
                    </Grid>
                  </Grid>
                  <Grid
                    className="d-flex justify-content-between align-items-center"
                    style={{}}
                  >
                    <Grid item xs>
                      <p style={noTitles}>
                        {detallesProductos && detallesProductos
                          ? calcularTotalKilos(detallesProductos).toFixed(2)
                          : 0}
                      </p>
                    </Grid>
                    <Grid item xs>
                      <p style={noTitles}>
                        {confirmDataProductos}{" "}
                        {detallesProductos && detallesProductos
                          ? calcularSubtotal(detallesProductos).toFixed(2)
                          : 0}
                      </p>
                    </Grid>
                    <Grid item xs>
                      <p style={noTitles}>
                        {confirmDataProductos}{" "}
                        {detallesProductos && detallesProductos
                          ? calcularDescuentos(detallesProductos).toFixed(2)
                          : 0}
                      </p>
                    </Grid>
                    <Grid item xs>
                      <p style={titles}>
                        {confirmDataProductos}{" "}
                        {detallesProductos && detallesProductos
                          ? calcularTotal(detallesProductos).toFixed(2)
                          : 0}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              <div style={{ marginBottom: "1.5rem" }}>
                <div className="col" style={titles}>
                  OBS/COMENTARIOS:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.comentario}
                  </span>
                </div>
                <div className="col" style={titles}>
                  TIENDA DE ENTREGA:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.tiendaEntrega}
                  </span>
                </div>
                <div className="col" style={titles}>
                  DOMICILIO DE ENTREGA:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.direccionEntrega}
                  </span>
                </div>
                <div className="col" style={titles}>
                  TELÉFONO ENTREGA:{" "}
                  <span style={noTitles}>
                    {props.presupuestoConfirm?.telefonoEntrega}
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{}}
              className="row row-cols-1 row-cols-sm-1 row-cols-md-1 "
            >
              <div
                className="col text-center"
                style={{
                  color: "white",
                  backgroundColor: "black",
                  fontWeight: "bold",
                  padding: "1.25rem",
                }}
              >
                <h3 className="text-center">ATENCIÓN</h3>
                <h5 className="text-center">
                  LA PRESENTE SOLICITUD DE COMPRA DEBERÁ SER APROBADA POR SU
                  COMERCIAL ASIGNADO
                </h5>
                <h5 className="text-center">
                  (VER ESTADO EN{" "}
                  <Link
                    href="#"
                    to={rutas.MIS_PRESUPUESTOS}
                    style={{ textDecoration: "none", color: colores.grisClaro }}
                  >
                    "MIS OPERACIONES"
                  </Link>
                  ) PARA FORMALIZAR LA COMPRA
                </h5>
                <br></br>
                <h5 className="text-center">
                  EL SIGUIENTE PEDIDO DE PRESUPUESTO ESTA SUJETO A VALIDACION DE
                  STOCK
                </h5>
                <br></br>
                <h5 className="text-center" style={{ color: "yellow" }}>
                  RECUERDEN QUE EL CAMIÓN COMPLETO NO DEBE SUPERAR LOS 27500
                  KILOS
                </h5>
              </div>
            </div>

            <div
              style={{ marginTop: "5vh" }}
              className="row row-cols-1 row-cols-sm-1 row-cols-md-1 "
            >
              <div className="col" style={titles}>
                OBSERVACIONES ADICIONALES:{" "}
              </div>
              <textarea value={textArea} onChange={handleChangeTextArea} />
              <div className="error-message">{error}</div>
            </div>
            <div
              style={{}}
              className="row row-cols-1 row-cols-sm-1 row-cols-md-1 "
            >
              <div
                className="col text-center"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  padding: "1.875rem",
                }}
              >
                <button
                  className={`btn ${props.loading ? "disabled" : ""}`}
                  disabled={props.error}
                  onClick={confirmarPresupuesto}
                  style={{
                    width: "12.5rem",
                    backgroundColor: colores.rojo,
                    color: "white",
                  }}
                >
                  CONFIRMAR SOLICITUD
                </button>
                {props.loading && (
                  <div style={{ margin: "1vw" }}>
                    {" "}
                    <CircularProgress />{" "}
                  </div>
                )}
              </div>
              {props.error && (
                <div
                  className="alert alert-danger text-center"
                  style={{ width: "17.5rem" }}
                  role="alert"
                >
                  {props?.error}
                </div>
              )}
              {props.error && (
                <div className="col text-center">
                  <button
                    className={`btn`}
                    onClick={volverMiCarrito}
                    style={{
                      width: "12.5rem",
                      backgroundColor: colores.rojo,
                      color: "white",
                    }}
                  >
                    {" "}
                    VOLVER MI CARRITO
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <AlertaImpuestos
        open={openAlertaImpuestos}
        handleClose={handleCloseDialog}
      /> */}

      {/* Popup para Pedido Firme */}
      <PedidoFirme
        open={openPedidoFirme}
        handleNext={handleNextPedidoFirme}
        handleSelectPedidoFirma={handleSelectPedidoFirma}
        esPedidoFirme={esPedidoFirme}
        mostrarAlertaImpuestos={
          props.presupuestoConfirm?.clasificacionEnvioId !== "Retira"
        }
      />

      {/* Términos y condiciones */}
      {openDialogTerminos && (
        <div className="d-flex flex-wrap">
          <div
            style={{
              height: "100%",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
              zIndex: "1",
              backgroundColor: "black",
              filter: "alpha(opacity=75)",
              opacity: 0.75,
            }}
          ></div>
          <div
            className="container"
            style={{
              position: "fixed",
              left: "50%",
              top: "25%",
              transform: "translate(-50%, -25%)",
              bottom: "0",
              zIndex: "2",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseTerminosCondiciones}
              sx={{
                position: "absolute",
                right: 36,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <div className="container" style={{ width: "100%" }}>
              <div
                style={{
                  backgroundColor: colores.grisClaro,
                  padding: "4.20rem",
                  borderRadius: "15px 15px 15px 15px",
                }}
              >
                <div
                  dangerouslySetInnerHTML={{ __html: terminosCondiciones }}
                ></div>
                <div>
                  <DownloadPoliticaReclamo
                    checked={checkedReclamos}
                    setChecked={setCheckedReclamos}
                  ></DownloadPoliticaReclamo>
                  <Checkbox
                    checked={checkedTerminos}
                    onChange={handleChangeTerminos}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  He leído y acepto los términos y condiciones.
                </div>
                <div style={{ textAlign: "center", margin: "2vw" }}>
                  <button
                    className={`btn ${props.loading ? "disabled" : ""}`}
                    disabled={!checkedTerminos || !checkedReclamos}
                    onClick={handleConfirmarTerminosCondiciones}
                    style={{
                      width: "12.5rem",
                      backgroundColor: colores.rojo,
                      color: "white",
                    }}
                  >
                    REALIZAR PEDIDO
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect(
  (state) => ({
    presupuesto: state.presupuestos.presupuesto,
    presupuestoConfirm: state.presupuestos.presupuestoConfirm,
    loading: state.presupuestos.loading,
    error: state.presupuestos.errorMsj,
    successPre: state.presupuestos.successPre,
    successGetTerminos: state.configuracion.successGetTerminos,
    terminos: state.configuracion.terminos,
    loadingTerminos: state.configuracion.loading,
  }),
  (dispatch) => ({
    // controller/FetchPreconfirm
    requestPresupuestoConfirm: (presupuestoId) =>
      dispatch(requestPresupuestoConfirm(presupuestoId)),
    //controller/ConfirmBudget
    requestConfirmacionPresupuesto: (presupuestoId, observaciones) =>
      dispatch(requestConfirmacionPresupuesto(presupuestoId, observaciones)),
    getTerminosCondiciones: () => dispatch(getTerminosCondiciones()),
  }),
)(Confirmar);
